import script from "./KnowledgeBaseHtmlContentDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./KnowledgeBaseHtmlContentDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./KnowledgeBaseHtmlContentDisplay.vue?vue&type=style&index=0&id=0eb8eed8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb8eed8"]])

export default __exports__